import {
  StyleSheet,
  TouchableOpacity,
  TextInput,
  Modal,
  ScrollView,
  Alert,
  ActivityIndicator,
  Switch,
  useWindowDimensions,
  Image,
  Dimensions,
} from "react-native";
import IconRefresh from "react-native-vector-icons/FontAwesome";
import IconEdit from "react-native-vector-icons/FontAwesome";
import * as ImagePicker from "expo-image-picker";
import * as DocumentPicker from "expo-document-picker";

import SuccessPopup from "../../../components/SuccessPopup";

import DataTable from "react-data-table-component";
import IconLoc from "react-native-vector-icons/MaterialIcons";

import { RadioButton, Button } from "react-native-paper";
import moment from "moment";
import { TabView, SceneMap, TabBar } from "react-native-tab-view";

import { CheckBox } from "react-native-elements";
import AsyncStorage from "@react-native-async-storage/async-storage";

import { DatePickerModal } from "react-native-paper-dates";
import { Dropdown } from "react-native-element-dropdown";

import { Text, View } from "../../../components/Themed";

import Icon from "react-native-vector-icons/AntDesign";
import React, { useState, useRef, useEffect } from "react";
import IconCross from "react-native-vector-icons/Entypo";
import { baseUrl, baseUrlimage, postData } from "../../../networking/api";
import { useFocusEffect } from "@react-navigation/native";
import { useSelector, useDispatch } from "react-redux";
import { projectHeader } from "../../../components/redux/actions";
import IconCheck from "react-native-vector-icons/MaterialCommunityIcons";

export default function EditProjectProfile({ navigation, route }) {
  var dispatch = useDispatch();
  const { Projects_Id } = route?.params;

  const [isVisible, setIsVisible] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [animating, setAnimating] = useState(true);
  const [isAdd, setisAdd] = useState(false);
  const [ProjectNameData, setProjectNameData] = useState([]);
  const [filterData, setFilteredDataSource] = useState([]);

  const [issuccessVisible, setissuccessVisible] = useState(false);
  const [responsestatus, setresponsestatus] = useState("");
  const [PopupMessage, setPopupMessage] = useState("");

  const [Lat, setLatitude] = useState("");
  const [Long, setLongitude] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [isOmegaLoading, setIsOmegaLoading] = useState(false);

  const [ProjectIdOmega, setProjectIdOmega] = useState("");

  const [ProjectID, setProjectID] = useState("");
  const [isProjectIDValid, setProjectIDValid] = useState(true);
  const [isProjectIDEntered, setProjectIDEntered] = useState(false);

  const [ProjectName, setProjectName] = useState("");
  const [isProjectNameValid, setProjectNameValid] = useState(true);
  const [isProjectNameEntered, setProjectNameEntered] = useState(false);

  const [ContractorName, setContractorName] = useState("");
  const [isContractorNameValid, setContractorNameValid] = useState(true);
  const [isContractorNameEntered, setContractorNameEntered] = useState(false);

  const [ClientName, setClientName] = useState("");
  const [isClientNameValid, setClientNameValid] = useState(true);
  const [isClientNameEntered, setClientNameEntered] = useState(false);

  const [ProjectDetails, setProjectDetails] = useState("");
  const [isProjectDetailsValid, setProjectDetailsValid] = useState(true);
  const [isProjectDetailsEntered, setProjectDetailsEntered] = useState(false);

  const [projectdeviceId, setProjectDeviceId] = useState(0);
  const [OmegaIdData, setOmegaIdData] = useState([]);
  const [OmegaDetails, setOmegaDetails] = useState([]);
  const [AnalogInput, setAnalogInput] = useState([]);
  const [DigitalInput, setDigitalInput] = useState([]);
  const [DataRecord, setDataRecord] = useState([]);
  const [userId, setUserId] = useState("");

  const [OmegavalueId, setOmegaValueiD] = useState("");
  const [shouldShow, setShouldShow] = useState(true);

  const [ProjectTypeData, setProjectTypeData] = useState([]);
  const [ProjectTypevalueId, setProjectTypeValueiD] = useState();

  const [OmegaIdValue, setOmegaIdValue] = useState(null);
  const [ProjectTypeValue, setProjectTypeValue] = useState(null);
  const [profileImage, setProfileImage] = useState("");
  const [profileImageError, setProfileImageError] = useState("");

  const [kmlFileData, setKmlFileData] = useState(null);
  const [kmlFileName, setKmlFileName] = useState("");
  const [kmlError, setKmlError] = useState("");

  const [ProjectIdError, setProjectIDError] = useState("");

  const [ProjectNameError, setProjectNameError] = useState("");
  const [ClientnameError, setClientnameError] = useState("");
  const [ProjectDetailsError, setProjectDetailsError] = useState("");
  const [ProjectTypeError, setProjectTypeError] = useState("");

  const [ContractorError, setContractorError] = useState("");

  const [pinError, setPinError] = useState("");
  const [khasaraError, setkhasaraError] = useState("");
  const [OmegaError, setOmegaError] = useState("");

  const [qualification_Error, setQualificationError] = useState("");
  const [isAssignchecked, setAssignChecked] = useState(1);
  const dropdownRefOmegaiD = useRef();
  const dropdownRefProjectType = useRef();

  const closeMenu = () => {
    dropdownRefOmegaiD.current.close();
    dropdownRefProjectType.current.close();
  };

  useEffect(() => {
    window.addEventListener("scroll", closeMenu);
    return () => window.removeEventListener("scroll", closeMenu);
  }, []);

  const [date, setDate] = React.useState<Date | undefined>(undefined);
  const [open, setOpen] = React.useState(false);
  const [dashboardName, setDashboardName] = useState([]);

  const [joinDate, setJoinDate] = React.useState<Date | undefined>(undefined);
  const [joinOpen, setJoinOpen] = React.useState(false);

  var alpha_pattern = new RegExp(/^[a-zA-Z0-9 ]*$/);

  var alpha_numeric = new RegExp(/^[a-z0-9][a-z0-9 ]{1,48}[a-z0-9]$/i);

  var Email_Id_pattern = new RegExp(
    /^\w+([\.-]?\w+)@\w+([\.-]?\w+)(\.\w\w+)+$/,
  );
  var password_pattern = new RegExp(
    /^[a-zA-Z0-9]+$/,
  );
  const regex = /^[0-9]*$/;

  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;
  const statusTableData = [
    { old_status: "Open", new_status: "" },
    { old_status: "Close", new_status: "" },
  ];
  const [originalStatusData, setOriginalStatusData] = useState([
    ...statusTableData,
  ]);
  const [statusData, setStatusData] = useState<any>([...statusTableData]);
  const [statusTableVisible, setStatusTableVisible] = useState(false);
  const [tempRowData, setTempRowData] = useState<any>({});

  const [originalSensorData, setOriginalSensorData] = useState([]);
  const [sensorData, setSensorData] = useState<any>([]);
  const [sensorTableVisible, setSensorTableVisible] = useState(false);
  const [tempRowSensorData, setTempRowSensorData] = useState<any>({});

  const [originalWaterMeterData, setOriginalWaterMeterData] = useState([]);
  const [waterMeterData, setWaterMeterData] = useState<any>([]);
  const [waterMeterTableVisible, setWaterMeterTableVisible] = useState(false);
  const [tempRowWaterMeterData, setTempRowWaterMeterData] = useState<any>({});

  const customStyles = {
    rows: {
      style: {
        minHeight: "30px", 
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        backgroundColor: "#319ef0a3",
        minHeight: "40px",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    headCells: {
      style: {
        justifyContent: "center",
        minHeight: "20px",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
      },
    },
    cells: {
      style: {
        paddingRight: "8px",
        justifyContent: "center",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          fontSize: 16,
          fontWeight: "400",
        },
      },
    },
  };
  const columns = [
    {
      name: "Output number",
      selector: (row) => row.value,
      sortable: true,
    },
    {
      name: "Output Name",
      selector: (row) => row.name,
      sortable: true,
    },
  ];
  const columnsAnalog = [
    {
      name: "Number",
      selector: (row) => row.value,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
  ];

  const columnDigitalInput = [
    {
      name: "Input number",
      selector: (row) => row.value,
      sortable: true,
    },
    {
      name: "Input Name",
      selector: (row) => row.name,
      sortable: true,
    },
  ];
  useEffect(() => {
    const getSwitchData = async () => {
      setIsLoading(true);

      try {
        const farmerTokenData = await AsyncStorage.getItem("farmerToken");
        const userToken = await AsyncStorage.getItem("userToken");
        const token = userToken ? userToken : farmerTokenData || "";

        fetch(`${baseUrl}new-dashboards/switch-list/${Projects_Id}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        })
          .then((data) => data.json())
          .then((response) => {
            if (response?.code == 1) {
              setTempRowData(response?.data);
              setStatusData(response?.data);
              setOriginalStatusData(response?.data);
            }
          })
          .catch((error) => {
            console.error("Error", error);
          });
      } catch (error) {
        console.error("Error", error);
      } finally {
        setIsLoading(false);
      }
    };
    getSwitchData();
  }, []);

  useEffect(() => {
    const getSwitchData = async () => {
      setIsLoading(true);

      try {
        const farmerTokenData = await AsyncStorage.getItem("farmerToken");
        const userToken = await AsyncStorage.getItem("userToken");
        const token = userToken ? userToken : farmerTokenData || "";

        fetch(`${baseUrl}new-dashboards/analog-list/${Projects_Id}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        })
          .then((data) => data.json())
          .then((response) => {
            if (response?.code == 1) {
              setTempRowSensorData(response?.data);
              setSensorData(response?.data);
              setOriginalSensorData(response?.data);
            }
          })
          .catch((error) => {
            console.error("Error", error);
          });
      } catch (error) {
        console.error("Error", error);
      } finally {
        setIsLoading(false);
      }
    };
    getSwitchData();
  }, []);
  useEffect(() => {
    const getWaterMeterData = async () => {
      setIsLoading(true);

      try {
        const farmerTokenData = await AsyncStorage.getItem("farmerToken");
        const userToken = await AsyncStorage.getItem("userToken");
        const token = userToken ? userToken : farmerTokenData || "";

        fetch(`${baseUrl}new-dashboards/water-meter-list/${Projects_Id}`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        })
          .then((data) => data.json())
          .then((response) => {
            if (response?.code == 1) {
              setTempRowWaterMeterData(response?.data);
              setWaterMeterData(response?.data);
              setOriginalWaterMeterData(response?.data);
            }
          })
          .catch((error) => {
            console.error("Error", error);
          });
      } catch (error) {
        console.error("Error", error);
      } finally {
        setIsLoading(false);
      }
    };
    getWaterMeterData();
  }, []);

  const getAllProjectData = async (sortdata: never[]) => {
    setIsLoading(true);
    if (sortdata.length > 0) {
      setProjectNameData(sortdata);
      setFilteredDataSource(sortdata);
    } else {
      try {
        var getProjectData = JSON.stringify({
          module: "project",
          relation: [],
        });
        const ProjectNameResponse = await postData(
          getProjectData,
          "masters/getMasterList",
        );
        setIsLoading(false);
        var code = ProjectNameResponse.code;
        if (code == 1) {
          setProjectNameData(ProjectNameResponse.data);
          setFilteredDataSource(ProjectNameResponse.data);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error", error);
      }
    }
  };
  const DigitalOutputRoute = () => (
    <View
      style={{
        flex: 1,
        justifyContent: "flex-start",
        backgroundColor: "#F6F9F9",
      }}
    >
      {" "}
      <View style={[styles.card, { flexGrow: 1 }]}>
        <View
          style={[
            styles.shadowProp,
            {
              backgroundColor: "white",
            },
          ]}
        >
          <View
            style={{
              width: "100%",
              backgroundColor: "#F6F9F9",
            }}
          >
            <View
              style={{
                borderWidth: 1,
                borderColor: "#e3e0e0",
              }}
            >
              <View>
                <DataTable
                  columns={columns}
                  data={OmegaDetails}
                  customStyles={customStyles}
                  pagination
                />
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );

  const AnalogInputRoute = () => (
    <View
      style={{
        flex: 1,
        justifyContent: "flex-start",
        backgroundColor: "#F6F9F9",
      }}
    >
      {" "}
      <View style={[styles.card, { flexGrow: 1 }]}>
        <View
          style={[
            styles.shadowProp,
            {
              backgroundColor: "white",
            },
          ]}
        >
          <View
            style={{
              width: "100%",
              backgroundColor: "#F6F9F9",
            }}
          >
            <View
              style={{
                borderWidth: 1,
                borderColor: "#e3e0e0",
              }}
            >
              <View>
                <DataTable
                  columns={columnsAnalog}
                  data={AnalogInput}
                  customStyles={customStyles}
                  pagination
                />
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
  const DigitalInputRoute = () => (
    <View
      style={{
        flex: 1,
        justifyContent: "flex-start",
        backgroundColor: "#F6F9F9",
      }}
    >
      {" "}
      <View style={[styles.card, { flexGrow: 1 }]}>
        <View
          style={[
            styles.shadowProp,
            {
              backgroundColor: "white",
            },
          ]}
        >
          <View
            style={{
              width: "100%",
              backgroundColor: "#F6F9F9",
            }}
          >
            <View
              style={{
                borderWidth: 1,
                borderColor: "#e3e0e0",
              }}
            >
              <View>
                <DataTable
                  columns={columnDigitalInput}
                  data={DigitalInput}
                  customStyles={customStyles}
                  pagination
                />
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );

  const renderScene = SceneMap({
    DigitalOutput: DigitalOutputRoute,
    DigitalInput: DigitalInputRoute,
    AnalogInput: AnalogInputRoute,
  });
  const layout = useWindowDimensions();

  const [index, setIndex] = React.useState(0);
  const [routes] = React.useState([
    { key: "DigitalOutput", title: "Digital Output" },

    { key: "DigitalInput", title: "Digital Input" },
    { key: "AnalogInput", title: "Analog Input" },
  ]);

  useFocusEffect(
    React.useCallback(() => {
      getAdminData();

      getProjectTypeList();
      getProjectProfileById();
      getAllProjectData([]);
      getOmegaDependentByProjectId();
      getDashboardNameDetails();
    }, []),
  );

  const getAdminData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");
    if (jsonValue != null) {
      var userDetailsresponse = JSON.parse(jsonValue);
      setUserId(userDetailsresponse.id);
    }
  };

  const renderOmegaIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {item.id === OmegavalueId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };
  const renderProjectTypeListItems = (item: any) => {
    return (
      <View style={styles.item}>
        {isAdd == true && <Text style={styles.textItem}>{item.type}</Text>}
        {isAdd == false && <Text style={styles.textItem}>{item.type}</Text>}
        {item.id === ProjectTypevalueId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </View>
    );
  };
  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.All,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
      base64: true,
    });

    setProfileImage(result.uri);

    if (!result.cancelled) {
      setProfileImage(result.uri);
    }
  };

  const pickKmlFile = async () => {
    const result = await DocumentPicker.getDocumentAsync({ type: "*/*" });
    if (result.type === "cancel") {
      return;
    }
    const fileNameLower = result.name ? result.name.toLowerCase() : "";
    const isKmz = fileNameLower.endsWith(".kmz");
    if (!result.name || (!fileNameLower.endsWith(".kml") && !isKmz)) {
      setKmlError("Please select a .kml or .kmz file");
      return;
    }
    try {
      let base64;
      if (result.file) {
        base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(result.file);
        });
      } else {
        const response = await fetch(result.uri);
        const blob = await response.blob();
        base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
      // The picker/blob mimetype isn't reliable across platforms, so the data
      // URI's mimetype is always rewritten based on the selected extension
      // (KMZ is a zip archive and must not be mislabeled as application/kml).
      const kmlMimeType = isKmz ? "application/vnd.google-earth.kmz" : "application/kml";
      setKmlFileData(
        base64.replace(/^data:[^;]*;base64,/, `data:${kmlMimeType};base64,`),
      );
      setKmlFileName(result.name);
      setKmlError("");
    } catch (error) {
      setKmlError("Unable to read the selected KML file");
      console.error("Error", error);
    }
  };

  const CheckEnteredData = async () => {
    setProjectNameEntered(true);

    setContractorNameEntered(true);
    setProjectDetailsEntered(true);
    setClientNameEntered(true);

    if (
      isProjectIDValid &&
      isProjectNameValid &&
      isContractorNameValid &&
      isClientNameValid &&
      isProjectDetailsValid
    ) {
      updateProjectProfileData();
      setProfileImageError("");
      setProjectIDError("");
      setProjectTypeError("");
      setContractorError("");
      setClientnameError("");
      setProjectDetailsError("");
    } else {
      if (ProjectIdError == "") {
        setProjectIDError("");
      }
      if (ProjectTypevalueId == "") {
        setProjectTypeError("Please select Project Type");
      }

      if (ContractorName == "") {
        setContractorError("Please enter Contractor name ");
      }



      if (ClientName == "") {
        setClientnameError("Please select Client name");
      }

      if (ProjectDetails == "") {
        setProjectDetailsError("Please select Project details");
      }
    }
  };

  const getProjectTypeList = async () => {
    setIsLoading(true);
    try {
      var ProjectTypeData = JSON.stringify({
        module: "project_type",
        relation: [],
      });
      const ProjectTypeList = await postData(
        ProjectTypeData,
        "masters/getMasterList",
      );
      setIsLoading(false);
      var code = ProjectTypeList.code;
      if (code == 1) {
        setProjectTypeData(ProjectTypeList.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const getProjectProfileById = async () => {
    setIsLoading(true);
    try {
      var ProfileData = JSON.stringify({
        module: "project",
        relation: [
          {
            module: "project_type",
          },
          {
            module: "project_devices",
            subModule: "devices_master",
          },
        ],
        id: Projects_Id,
      });

      const ProjectProfileDataById = await postData(
        ProfileData,
        "/masters/getMasterList",
      );
      setIsLoading(false);
      var code = ProjectProfileDataById.code;
      if (code == 1) {
        var profileUrl =
          baseUrlimage +
          "uploads/project_profile/" +
          ProjectProfileDataById.data[0].profile_pic;
        setProfileImage(profileUrl);
        setKmlFileName(ProjectProfileDataById.data[0].kml_file || "");
        setAssignChecked(ProjectProfileDataById.data[0].based_on);
        setProjectID(ProjectProfileDataById.data[0].project_code);
        setProjectName(ProjectProfileDataById.data[0].project_name);
        if (ProjectProfileDataById.data[0].project_devices.length > 0) {
          setProjectDeviceId(
            ProjectProfileDataById.data[0].project_devices[0].id,
          );
          if (
            ProjectProfileDataById.data[0].project_devices[0].devices_master !==
            null
          ) {
            setOmegaIdValue(
              ProjectProfileDataById.data[0].project_devices[0].devices_master
                .device_name,
            );
            setOmegaValueiD(
              ProjectProfileDataById.data[0].project_devices[0].devices_master
                .id,
            );
          } else {
            const value = "None";
            setOmegaIdValue(value);
            setOmegaValueiD("0");
          }
        } else {
          const value = "None";
          setOmegaIdValue(value);
          setOmegaValueiD("0");
        }

        setProjectTypeValueiD(ProjectProfileDataById.data[0].project_type.id);
        setProjectTypeValue(ProjectProfileDataById.data[0].project_type.type);
        setContractorName(ProjectProfileDataById.data[0].contractor);
        setClientName(ProjectProfileDataById.data[0].client);
        setProjectDetails(ProjectProfileDataById.data[0].project_details);
        setLatitude(
          ProjectProfileDataById.data[0].project_devices[0].devices_master.lat,
        );
        setLongitude(
          ProjectProfileDataById.data[0].project_devices[0].devices_master.long,
        );
        getOmegaDetails(
          ProjectProfileDataById.data[0].project_devices[0].devices_master.id,
        );
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const getOmegaDependentByProjectId = async () => {
    setIsLoading(true);
    try {
      var OmegaIdData = JSON.stringify({
        column: "project_id",
        value: Projects_Id,
        module: "devices_master",
      });
      const OmegaIdList = await postData(
        OmegaIdData,
        "masters/getDependentMasterList",
      );
      setIsLoading(false);
      var code = OmegaIdList.code;
      if (code == 1) {
        var mergeData = OmegaIdList.data;
        mergeData.unshift({
          id: 0,
          omega_id: "",
          device_name: "None",
          lat: "",
          long: "",
        });
        setOmegaIdData(mergeData);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const getOmegaDetails = async (deviceId) => {
    setIsLoading(true);
    try {
      var OmegaDetails = JSON.stringify({
        device_id: deviceId,
      });

      const OmegaDetailsResponse = await postData(
        OmegaDetails,
        "masters/getOmegaDetails",
      );
      setIsLoading(false);
      var code = OmegaDetailsResponse.code;
      if (code == 1) {

        setDataRecord(OmegaDetailsResponse.data);
        setOmegaDetails(OmegaDetailsResponse.data[0].valves);
        setAnalogInput(OmegaDetailsResponse.data[0].analogInput);
        setDigitalInput(OmegaDetailsResponse.data[0].digitalInput);
      } else {
        setDataRecord(OmegaDetailsResponse.data);

        setIsLoading(false);

      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };

  const getOmegaIdList = async () => {
    setIsOmegaLoading(true);
    if (ProjectID == "") {
      setProjectIDError("Please enter Project Id");
    }
    if (ClientName == "") {
      setClientnameError("Please select Client name");
    }
    if (ContractorName == "") {
      setContractorError("Please enter Contractor name ");
    }
    if (ProjectTypevalueId == "") {
      setProjectTypeError("Please select Project Type");
    }
    try {
      var OmegaIdData = JSON.stringify({
        id: ProjectID,
        client: ClientName,
        contractor: ContractorName,
        project_type_id: ProjectTypevalueId,
      });
      const OmegaIdList = await postData(
        OmegaIdData,
        "masters/getOmegaFromBermad",
      );
      setIsOmegaLoading(false);
      var code = OmegaIdList.code;
      if (code == 1) {
        setProjectName(OmegaIdList.data[0].project_name);
        setOmegaIdData(OmegaIdList.data);
      } else {
        setIsOmegaLoading(false);
      }
    } catch (error) {
      setIsOmegaLoading(false);
      console.error("Error", error);
    }
  };
  const updateProjectProfileData = async () => {
    setIsLoading(true);
    try {
      var projectPayload = {
        id: Projects_Id,
        modelName: "project", 
        inputData: {
          project_type_id: ProjectTypevalueId,
          project_name: ProjectName,
          client: ClientName,
          contractor: ContractorName,
          omega_id: OmegaIdValue,
          project_details: ProjectDetails,
          active: 1,
          based_on: isAssignchecked,
        },
        relation: {
          subModelName: "project_devices",
          subModelInputData: [
            {
              id: projectdeviceId,
              project_id: Projects_Id,
              device_id: OmegavalueId,
              active: 1,
            },
          ],
        },
      };
      if (kmlFileData) {
        projectPayload.uploadImage = {
          imagePath: kmlFileData,
          folderPath: "./uploads/project_kml",
          field_name: "kml_file",
        };
      }
      var ProjectMasterData = JSON.stringify(projectPayload);

      const FaarmerProfileCreateResponse = await postData(
        ProjectMasterData,
        "masters/profileCreationAndUpdation",
      );

      setIsLoading(false);

      var code = FaarmerProfileCreateResponse.code;
      if (code == 1) {
        if (tempArray.length == 0) {
          setPopupMessage("Record Updated Successfully");
          setissuccessVisible(true);
          setresponsestatus("success");
          dispatch(projectHeader());
          navigation.navigate("ProjectProfile");
        } else {
          updateProjectWiseDashboardList();
        }
      } else {
        setIsLoading(false);
        setissuccessVisible(true);
        setresponsestatus("failed");
        setPopupMessage(FaarmerProfileCreateResponse.message);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getDashboardNameDetails = async () => {
    setIsLoading(true);

    try {
      const farmerTokenData = await AsyncStorage.getItem("farmerToken");
      const userToken = await AsyncStorage.getItem("userToken");
      const token = userToken ? userToken : farmerTokenData || "";

      fetch(
        `${baseUrl}masters/getProjectWiseDashboardMastersList/${Projects_Id}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      )
        .then((data) => data.json())
        .then((response) => {
          if (response.code == 1) {
            setDashboardName(response.data);
          }
        })
        .catch((error) => {
          console.error("Error", error);
        });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateProjectWiseDashboardList = async () => {
    setIsLoading(true);
    try {
      var dashboardNameBody = JSON.stringify({
        project_id: Projects_Id,
        dashboard_name_array: tempArray,
      });

      const updateProjectWiseDashboardResponse = await postData(
        dashboardNameBody,
        "masters/updateProjectWiseDashboardMastersList",
      );
      setIsLoading(false);

      var code = updateProjectWiseDashboardResponse.code;
      if (code == 1) {
        setPopupMessage("Record Updated Successfully");
        setissuccessVisible(true);
        setresponsestatus("success");
        dispatch(projectHeader());
        navigation.navigate("ProjectProfile");
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [tempArray, setTempArray] = useState<any>([]);
  const customDashboardNameStyles = {
    rows: {
      style: {
        minHeight: "25px", 
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        backgroundColor: "#319ef0a3",
        minHeight: "40px",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    headCells: {
      style: {
        justifyContent: "center",
        minHeight: "20px",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", 
        paddingRight: "8px",
        justifyContent: "center",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          fontSize: 16,
          fontWeight: "400",
        },
      },
    },
  };
  const columnsDashboardName = [
    {
      name: "Sr. No",
      selector: (row, index) => row?.sr_index,
      sortable: true,
    },
    {
      name: "Dashboard Name",
      selector: (row) => row.old_dashboard_name,
      sortable: true,
    },
    {
      name: "New Dashboard Name",
      selector: (row) => (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginLeft:
              row?.dashboard_id == 10 ||
              row?.dashboard_id == 7 ||
              row?.dashboard_id == 8
                ? 30
                : 0,
          }}
        >
          <TextInput
            value={row.new_dashboard_name}
            style={styles.input}
            placeholder="Enter new name"
            onChangeText={(text) => {
              var dashboard_master_id = row.dashboard_id;
              var new_dashboard_name = text;
              row.new_dashboard_name = text;
              let data = tempArray.find(
                (object) => object["dashboard_master_id"] === row.dashboard_id,
              );
              if (data !== undefined) {
                const newState = tempArray.map((obj) => {
                  if (obj.dashboard_master_id === row.dashboard_id) {
                    return { ...obj, new_dashboard_name: text };
                  }
                  return obj;
                });
                setTempArray(newState);
              } else {
                let data = { dashboard_master_id, new_dashboard_name };
                tempArray.push(data);
              }
            }}
          />
          {row?.dashboard_id == 7 && (
            <TouchableOpacity
              onPress={() => {
                setWaterMeterTableVisible(true);
                setTempRowWaterMeterData(row);

                if (row?.status !== null) {
                  setWaterMeterData(row?.status);
                }
              }}
              style={{ marginLeft: 10 }}
            >
              <IconLoc name="remove-red-eye" size={24} color={"black"} />
            </TouchableOpacity>
          )}
          {row?.dashboard_id == 8 && (
            <TouchableOpacity
              onPress={() => {
                setSensorTableVisible(true);
                setTempRowSensorData(row);

                if (row?.status !== null) {
                  setSensorData(row?.status);
                }
              }}
              style={{ marginLeft: 10 }}
            >
              <IconLoc name="remove-red-eye" size={24} color={"black"} />
            </TouchableOpacity>
          )}
          {row?.dashboard_id == 10 && (
            <TouchableOpacity
              onPress={() => {
                setStatusTableVisible(true);
                setTempRowData(row);

                if (row?.status !== null) {
                  setStatusData(row?.status);
                }
              }}
              style={{ marginLeft: 10 }}
            >
              <IconLoc name="remove-red-eye" size={24} color={"black"} />
            </TouchableOpacity>
          )}
        </View>
      ),
      sortable: true,
    },
  ];

  const columnsStatusName = [
    {
      name: "Sr. No",
      selector: (row: any, index: any) => index + 1,
      sortable: true,
    },
    {
      name: "Switch Name",
      selector: (row: any) => row.old_switch,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row: any) => row.old_status,
      sortable: true,
    },
    {
      name: "Updated Switch Name",
      selector: (row: any) => (
        <TextInput
          value={row?.switch || row?.old_switch}
          style={styles.input}
          placeholder="Enter Updated Switch Name"
          onChangeText={(text) => {
            const updatedData = statusData.map((r) =>
              r === row ? { ...r, switch: text } : r,
            );
            setStatusData(updatedData);
          }}
        />
      ),
      sortable: true,
    },
    {
      name: "Updated Status",
      selector: (row: any) => (
        <TextInput
          value={row?.new_status}
          style={styles.input}
          placeholder="Enter Updated Status"
          onChangeText={(text) => {
            const updatedData = statusData.map((r) =>
              r === row ? { ...r, new_status: text } : r,
            );
            setStatusData(updatedData);
          }}
        />
      ),
      sortable: true,
    },
    {
      name: "Is Shown",
      selector: (row: any) => (
        <IconCheck
          name={row?.is_shown ? "checkbox-marked" : "checkbox-blank-outline"}
          size={24}
          color={row?.is_shown ? "#1868AE" : "grey"}
          onPress={() => {
            const updatedData = statusData.map((r) =>
              r === row ? { ...r, is_shown: !r.is_shown } : r,
            );
            setStatusData(updatedData);
          }}
        />
      ),
      sortable: true,
    },
  ];
  const columnsSensorName = [
    {
      name: "Sr. No",
      selector: (row: any, index: any) => index + 1,
      sortable: true,
    },
    {
      name: "Sensor Name",
      selector: (row: any) => row.old_analog_name,
      sortable: true,
    },

    {
      name: "Updated Sensor Name",
      selector: (row: any) => (
        <TextInput
          value={row?.analog_name || row?.analog_name}
          style={styles.input}
          placeholder="Enter Updated Sensor Name"
          onChangeText={(text) => {
            const updatedData = sensorData.map((r) =>
              r === row ? { ...r, analog_name: text } : r,
            );
            setSensorData(updatedData);
          }}
        />
      ),
      sortable: true,
    },

    {
      name: "Is Shown",
      selector: (row: any) => (
        <IconCheck
          name={row?.is_shown ? "checkbox-marked" : "checkbox-blank-outline"}
          size={24}
          color={row?.is_shown ? "#1868AE" : "grey"}
          onPress={() => {
            const updatedData = sensorData.map((r) =>
              r === row ? { ...r, is_shown: !r.is_shown } : r,
            );
            setSensorData(updatedData);
          }}
        />
      ),
      sortable: true,
    },
  ];
  const columnsWaterMeterName = [
    {
      name: "Sr. No",
      selector: (row: any, index: any) => index + 1,
      sortable: true,
    },
    {
      name: "Water Meter Name",
      selector: (row: any) => row.old_meter,
      sortable: true,
    },

    {
      name: "Updated Water Meter Name",
      selector: (row: any) => (
        <TextInput
          value={row?.meter || row?.old_meter}
          style={styles.input}
          placeholder="Enter Updated Water Meter Name"
          onChangeText={(text) => {
            const updatedData = waterMeterData.map((r) =>
              r === row ? { ...r, meter: text } : r,
            );
            setWaterMeterData(updatedData);
          }}
        />
      ),
      sortable: true,
    },

    {
      name: "Is Shown",
      selector: (row: any) => (
        <IconCheck
          name={row?.is_shown ? "checkbox-marked" : "checkbox-blank-outline"}
          size={24}
          color={row?.is_shown ? "#1868AE" : "grey"}
          onPress={() => {
            const updatedData = waterMeterData.map((r) =>
              r === row ? { ...r, is_shown: !r.is_shown } : r,
            );
            setWaterMeterData(updatedData);
          }}
        />
      ),
      sortable: true,
    },
  ];

  const handleCancel = () => {
    setStatusData([...originalStatusData]);
    setStatusTableVisible(false);
  };
  const handleSensorCancel = () => {
    setSensorData([...originalSensorData]);
    setSensorTableVisible(false);
  };
  const handleWaterMeterCancel = () => {
    setWaterMeterData([...originalWaterMeterData]);
    setWaterMeterTableVisible(false);
  };

  const handleSaveStatus = () => {
    const dashboardReportId = tempRowData?.dashboard_id;
    const newDashboardName = tempRowData?.new_dashboard_name;
    const statusDataCopy = [...statusData];
    const dataIndex = tempArray.findIndex(
      (obj: any) => obj.dashboard_master_id == dashboardReportId,
    );
    if (dataIndex !== -1) {
      const updatedTempArray = tempArray.map((obj: any, index: any) =>
        index === dataIndex ? { ...obj, status: statusDataCopy } : obj,
      );
      setTempArray(updatedTempArray);
    } else {
      const newData = {
        dashboard_master_id: dashboardReportId,
        new_dashboard_name: newDashboardName,
        status: statusDataCopy,
      };
      setTempArray([...tempArray, newData]);
    }
    const updatedDashboardName: any = [...dashboardName];
    const itemIndex = updatedDashboardName.findIndex(
      (item: any) => item?.dashboard_id === dashboardReportId,
    );
    if (itemIndex !== -1) {
      updatedDashboardName[itemIndex] = {
        ...updatedDashboardName[itemIndex],
        status: statusDataCopy,
      };
    } else {
      updatedDashboardName.push({
        ...tempRowData,
        status: statusDataCopy,
      });
    }

    setDashboardName(updatedDashboardName);
    setStatusData([...originalStatusData]);
    setStatusTableVisible(false);
  };
  const handleSaveSensor = () => {
    const dashboardReportId = tempRowSensorData?.dashboard_id;
    const newDashboardName = tempRowSensorData?.new_dashboard_name;
    const statusDataCopy = [...sensorData];
    const dataIndex = tempArray.findIndex(
      (obj: any) => obj.dashboard_master_id == dashboardReportId,
    );
    if (dataIndex !== -1) {
      const updatedTempArray = tempArray.map((obj: any, index: any) =>
        index === dataIndex ? { ...obj, status: statusDataCopy } : obj,
      );
      setTempArray(updatedTempArray);
    } else {
      const newData = {
        dashboard_master_id: dashboardReportId,
        new_dashboard_name: newDashboardName,
        status: statusDataCopy,
      };
      setTempArray([...tempArray, newData]);
    }
    const updatedDashboardName: any = [...dashboardName];
    const itemIndex = updatedDashboardName.findIndex(
      (item: any) => item?.dashboard_id === dashboardReportId,
    );
    if (itemIndex !== -1) {
      updatedDashboardName[itemIndex] = {
        ...updatedDashboardName[itemIndex],
        status: statusDataCopy,
      };
    } else {
      updatedDashboardName.push({
        ...tempRowSensorData,
        status: statusDataCopy,
      });
    }

    setDashboardName(updatedDashboardName);
    setSensorData([...originalSensorData]);
    setSensorTableVisible(false);
  };
  const handleSaveWaterMeter = () => {
    const dashboardReportId = tempRowWaterMeterData?.dashboard_id;
    const newDashboardName = tempRowWaterMeterData?.new_dashboard_name;
    const statusDataCopy = [...waterMeterData];
    const dataIndex = tempArray.findIndex(
      (obj: any) => obj.dashboard_master_id == dashboardReportId,
    );
    if (dataIndex !== -1) {
      const updatedTempArray = tempArray.map((obj: any, index: any) =>
        index === dataIndex ? { ...obj, status: statusDataCopy } : obj,
      );
      setTempArray(updatedTempArray);
    } else {
      const newData = {
        dashboard_master_id: dashboardReportId,
        new_dashboard_name: newDashboardName,
        status: statusDataCopy,
      };
      setTempArray([...tempArray, newData]);
    }
    const updatedDashboardName: any = [...dashboardName];
    const itemIndex = updatedDashboardName.findIndex(
      (item: any) => item?.dashboard_id === dashboardReportId,
    );
    if (itemIndex !== -1) {
      updatedDashboardName[itemIndex] = {
        ...updatedDashboardName[itemIndex],
        status: statusDataCopy,
      };
    } else {
      updatedDashboardName.push({
        ...tempRowWaterMeterData,
        status: statusDataCopy,
      });
    }

    setDashboardName(updatedDashboardName);
    setWaterMeterData([...originalWaterMeterData]);
    setWaterMeterTableVisible(false);
  };

  const popUp = () => {
    return (
      <View>
        <Modal visible={statusTableVisible} transparent={true}>
          <View
            style={{
              flex: 1,
              backgroundColor: "rgba(0,0,0,0.5)",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{ width: "60%", backgroundColor: "#fff", padding: "3%" }}
            >
              <View
                style={[
                  styles.shadowProp,
                  {
                    backgroundColor: "white",
                    borderWidth: 1,
                    borderColor: "#e3e0e0",
                  },
                ]}
              >
                <DataTable
                  columns={columnsStatusName}
                  data={statusData}
                  customStyles={customDashboardNameStyles}
                  pagination
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 25]}
                />
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  marginTop: "3%",
                }}
              >
                <TouchableOpacity
                  style={
                    isMobile
                      ? {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "30%",
                          marginRight: 10,
                        }
                      : {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "15%",
                          marginRight: 10,
                        }
                  }
                  onPress={() => {
                    handleSaveStatus();
                  }}
                >
                  <Text style={styles.btnText}>Save</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={
                    isMobile
                      ? {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "30%",
                        }
                      : {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "15%",
                        }
                  }
                  onPress={() => {
                    handleCancel();
                  }}
                >
                  <Text style={styles.btnText}>Cancel</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Modal>
      </View>
    );
  };
  const sensorPopUp = () => {
    return (
      <View>
        <Modal visible={sensorTableVisible} transparent={true}>
          <View
            style={{
              flex: 1,
              backgroundColor: "rgba(0,0,0,0.5)",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{ width: "60%", backgroundColor: "#fff", padding: "3%" }}
            >
              <View
                style={[
                  styles.shadowProp,
                  {
                    backgroundColor: "white",
                    borderWidth: 1,
                    borderColor: "#e3e0e0",
                  },
                ]}
              >
                <DataTable
                  columns={columnsSensorName}
                  data={sensorData}
                  customStyles={customDashboardNameStyles}
                  pagination
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 25]}
                />
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  marginTop: "3%",
                }}
              >
                <TouchableOpacity
                  style={
                    isMobile
                      ? {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "30%",
                          marginRight: 10,
                        }
                      : {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "15%",
                          marginRight: 10,
                        }
                  }
                  onPress={() => {
                    handleSaveSensor();
                  }}
                >
                  <Text style={styles.btnText}>Save</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={
                    isMobile
                      ? {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "30%",
                        }
                      : {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "15%",
                        }
                  }
                  onPress={() => {
                    handleSensorCancel();
                  }}
                >
                  <Text style={styles.btnText}>Cancel</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Modal>
      </View>
    );
  };
  const waterMeterPopUp = () => {
    return (
      <View>
        <Modal visible={waterMeterTableVisible} transparent={true}>
          <View
            style={{
              flex: 1,
              backgroundColor: "rgba(0,0,0,0.5)",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{ width: "60%", backgroundColor: "#fff", padding: "3%" }}
            >
              <View
                style={[
                  styles.shadowProp,
                  {
                    backgroundColor: "white",
                    borderWidth: 1,
                    borderColor: "#e3e0e0",
                  },
                ]}
              >
                <DataTable
                  columns={columnsWaterMeterName}
                  data={waterMeterData}
                  customStyles={customDashboardNameStyles}
                  pagination
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 25]}
                />
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  marginTop: "3%",
                }}
              >
                <TouchableOpacity
                  style={
                    isMobile
                      ? {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "30%",
                          marginRight: 10,
                        }
                      : {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "15%",
                          marginRight: 10,
                        }
                  }
                  onPress={() => {
                    handleSaveWaterMeter();
                  }}
                >
                  <Text style={styles.btnText}>Save</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={
                    isMobile
                      ? {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "30%",
                        }
                      : {
                          alignItems: "center",
                          backgroundColor: "#006EB9",
                          padding: 10,
                          borderWidth: 1,
                          borderColor: "#006EB9",
                          width: "15%",
                        }
                  }
                  onPress={() => {
                    handleWaterMeterCancel();
                  }}
                >
                  <Text style={styles.btnText}>Cancel</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Modal>
      </View>
    );
  };

  const custDataTable = () => {
    return <View style={{ height: 100, width: "100%" }}></View>;
  };
  return (
    <View style={styles.container}>
      <SuccessPopup
        visible={issuccessVisible}
        PopupMessage={PopupMessage}
        Responsestatus={responsestatus}
        onChange={() => setissuccessVisible(false)}
      />
      {popUp()}
      {sensorPopUp()}
      {waterMeterPopUp()}

      <View style={{ flexDirection: "row", width: "100%", marginTop: "5%" }}>
        {" "}
        <View style={{ flex: 4, margin: 10 }}>
          <Text style={styles.lableText}>
            Profile {">"}{" "}
            <Text onPress={() => navigation.navigate("ProjectProfile")}>
              {" "}
              Project Profile{" "}
            </Text>{" "}
            {">"} Edit Project Profile
          </Text>
        </View>
       
      </View>

      <View style={[styles.card, { flexGrow: 1 }]}>
        {isLoading ? (
          <ActivityIndicator
            color="#1DA1F2"
            visible={isLoading}
            textContent={"Loading..."}
            size={80}
          />
        ) : (
          <View
            style={
              isMobile
                ? [
                    styles.shadowProp,
                    {
                      backgroundColor: "white",
                      borderRadius: 8,
                      paddingVertical: 0,
                      paddingHorizontal: 25,
                      justifyContent: "center",
                      alignContent: "center",
                      alignItems: "center",
                    },
                  ]
                : [
                    styles.shadowProp,
                    {
                      backgroundColor: "white",
                      borderRadius: 8,
                      paddingVertical: 0,
                      paddingHorizontal: 25,
                      justifyContent: "center",
                      alignContent: "center",
                      alignItems: "center",
                    },
                  ]
            }
          >
            <View
              style={
                isMobile
                  ? {
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }
                  : {
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "row",
                      width: "100%",
                    }
              }
            >
              <View
                style={
                  isMobile
                    ? { marginLeft: "10%" }
                    : { flex: 1, marginLeft: "10%" }
                }
              >
                <View
                  style={{
                    borderRadius: 10,
                    padding: 10,
                    margin: 7,
                  }}
                >
                  <View
                    style={
                      isMobile
                        ? {
                            flex: 1,
                            alignItems: "flex-start",
                            padding: 10,
                            marginLeft: 10,
                          }
                        : { flex: 1, alignItems: "flex-start", padding: 10 }
                    }
                  >
                   
                    <TouchableOpacity
                      style={{
                        backgroundColor: profileImage ? "" : "grey",
                        padding: 10,
                      }}
                      onPress={pickImage}
                    >
                      <Image
                        source={
                          profileImage
                            ? { uri: profileImage }
                            : require("../../../assets/images/projectImg.png")
                        }
                        style={
                          isMobile
                            ? { width: 80, height: 80, borderWidth: 1 }
                            : { width: 100, height: 100, borderWidth: 1 }
                        }
                      />
                    </TouchableOpacity>
                  </View>

                  <View
                    style={
                      isMobile
                        ? {
                            alignItems: "flex-start",
                            padding: 10,
                            marginLeft: 10,
                          }
                        : { alignItems: "flex-start", padding: 10 }
                    }
                  >
                    <Text style={styles.lableText}>Project Boundary (KML/KMZ)</Text>
                    <TouchableOpacity
                      style={{
                        backgroundColor: "#319ef0a3",
                        paddingVertical: 8,
                        paddingHorizontal: 12,
                        borderRadius: 5,
                        marginTop: 5,
                      }}
                      onPress={pickKmlFile}
                    >
                      <Text style={{ color: "#000" }}>
                        {kmlFileName ? "Change KML File" : "Upload KML File"}
                      </Text>
                    </TouchableOpacity>
                    {kmlFileName ? (
                      <Text style={{ marginTop: 5 }}>{kmlFileName}</Text>
                    ) : null}
                    <Text style={[styles.error_text]}>{kmlError}</Text>
                  </View>

                  <View
                    style={
                      isMobile ? { marginLeft: -45, marginTop: -15 } : null
                    }
                  >
                    <Text style={styles.lableText}>Project Code </Text>
                    <View
                      style={
                        isMobile
                          ? { flexDirection: "row", width: "115%" }
                          : { flexDirection: "row" }
                      }
                    >
                      <TextInput
                        style={[styles.input, { backgroundColor: "#DEDEDE" }]}
                        placeholder="Enter Project code"
                        value={ProjectID}
                        editable={false}
                        onChangeText={(value) => {
                          setProjectIDValid(false);
                          setProjectID(value);
                          if (value.length == 0) {
                            setProjectIDError("Please enter Project iD");
                          } else if (!alpha_numeric.test(value)) {
                            setProjectIDError("Please enter alphanumeric only");
                          } else {
                            setProjectIDValid(true);
                            setProjectIDError("");
                          }
                        }}
                      />
                      <View style={{ marginLeft: 0, padding: 10 }}>
                        {isOmegaLoading ? (
                          <ActivityIndicator
                            color="#1DA1F2"
                            visible={isLoading}
                            textContent={"Loading..."}
                            size={40}
                          />
                        ) : (
                          <IconRefresh
                            name="refresh"
                            size={30}
                            onPress={() => getOmegaIdList()}
                          />
                        )}{" "}
                      </View>
                    </View>

                    <Text style={[styles.error_text]}>{ProjectNameError}</Text>
                  </View>

                  <View
                    style={
                      isMobile ? { marginLeft: -45, marginTop: -15 } : null
                    }
                  >
                    <Text style={styles.lableText}>Project Type</Text>
                    <View>
                      <Dropdown
                        ref={dropdownRefProjectType}
                        style={
                          isMobile
                            ? {
                                borderColor: "#c3c3c3",
                                width: "110%",
                                borderWidth: 1,
                                borderRadius: 2,
                                height: 40,
                                outlineStyle: "none",
                                padding: 10,
                                marginTop: 5,
                                marginBottom: 5,
                              }
                            : styles.dropdown
                        }
                        placeholderStyle={styles.placeholderStyle}
                        selectedTextStyle={styles.selectedTextStyle}
                        inputSearchStyle={styles.inputSearchStyle}
                        iconStyle={styles.iconStyle}
                        data={ProjectTypeData}
                        search
                        maxHeight={300}
                        labelField="type"
                        valueField="id"
                        placeholder={
                          ProjectTypeValue
                            ? ProjectTypeValue
                            : "Select Project type"
                        }
                        searchPlaceholder="Search..."
                        value={ProjectTypeValue}
                        onChange={(item) => {
                          setProjectTypeValue(item.type);
                          setProjectTypeValueiD(item.id);
                          setProjectTypeError("");
                        }}
                        renderItem={renderProjectTypeListItems}
                      />
                      <Text style={[styles.error_text]}>
                        {ProjectTypeError}
                      </Text>
                    </View>
                  </View>

                  <View
                    style={
                      isMobile ? { marginLeft: -45, marginTop: -15 } : null
                    }
                  >
                    <Text style={styles.lableText}>Contractor Name </Text>
                    <TextInput
                      style={
                        isMobile
                          ? {
                              borderColor: "#c3c3c3",
                              width: "110%",
                              borderWidth: 1,
                              borderRadius: 4,
                              padding: 10,
                              marginTop: 4,
                              marginBottom: 6,
                            }
                          : styles.input
                      }
                      placeholder="Enter Contractor name"
                      value={ContractorName}
                      onChangeText={(value) => {
                        setContractorNameValid(false);
                        setContractorName(value);
                        if (value.length == 0) {
                          setContractorError("Please enter Contractor name");
                        }
                        else {
                          setContractorNameValid(true);
                          setContractorError("");
                        }
                      }}
                    />
                  </View>

                  <Text style={[styles.error_text]}>{ContractorError}</Text>

                  <View
                    style={
                      isMobile ? { marginLeft: -45, marginTop: -15 } : null
                    }
                  >
                    <Text style={styles.lableText}>Omega name</Text>
                    <View style={{ flexDirection: "row" }}>
                      <View style={{ width: "100%" }}>
                        <View>
                          <Dropdown
                            ref={dropdownRefOmegaiD}
                            style={
                              isMobile
                                ? {
                                    borderColor: "#c3c3c3",
                                    width: "110%",
                                    borderWidth: 1,
                                    borderRadius: 2,
                                    height: 40,
                                    outlineStyle: "none",
                                    padding: 10,
                                    marginTop: 5,
                                    marginBottom: 5,
                                  }
                                : styles.dropdown
                            }
                            placeholderStyle={styles.placeholderStyle}
                            selectedTextStyle={styles.selectedTextStyle}
                            inputSearchStyle={styles.inputSearchStyle}
                            iconStyle={styles.iconStyle}
                            data={OmegaIdData}
                            search
                            maxHeight={300}
                            labelField="device_name"
                            valueField="device_name"
                            placeholder={
                              OmegaIdValue ? OmegaIdValue : "Select Omega name"
                            }
                            searchPlaceholder="Search..."
                            value={OmegaIdValue}
                            onChange={(item) => {
                              setOmegaIdValue(item.device_name);
                              setOmegaValueiD(item.id);
                              setOmegaError("");

                              getOmegaDetails(item.id);

                              setLatitude(item.lat);
                              setLongitude(item.long);
                              setProjectIdOmega(item.project_id);

                            }}
                            renderItem={renderOmegaIdListItems}
                          />
                          <Text style={[styles.error_text]}>{OmegaError}</Text>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
              <View
                style={
                  isMobile
                    ? {
                        borderRadius: 10,
                        padding: 10,
                        marginBottom: "0%",
                      }
                    : {
                        flex: 1,
                        marginTop: 53,
                        borderRadius: 10,
                        padding: 10,
                        margin: 150,
                        marginBottom: "0%",
                      }
                }
              >
                <View
                  style={isMobile ? { marginLeft: -10, marginTop: -30 } : null}
                >
                  <Text style={styles.lableText}>Project Name</Text>
                  <TextInput
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "105%",
                            borderWidth: 1,
                            borderRadius: 4,
                            padding: 10,
                            marginTop: 4,
                            marginBottom: 6,
                            backgroundColor: "#DEDEDE",
                          }
                        : [styles.input, { backgroundColor: "#DEDEDE" }]
                    }
                    value={ProjectName}
                    editable={false}
                  />

                  <Text style={[styles.error_text]}>{ProjectNameError}</Text>
                </View>

                <View
                  style={isMobile ? { marginLeft: -15, marginTop: -10 } : null}
                >
                  <Text style={styles.lableText}>Client Name </Text>
                  <TextInput
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "105%",
                            borderWidth: 1,
                            borderRadius: 4,
                            padding: 10,
                            marginTop: 4,
                            marginBottom: 6,
                          }
                        : styles.input
                    }
                    placeholder="Enter Client name"
                    value={ClientName}
                    onChangeText={(value) => {
                      setClientNameValid(false);
                      setClientName(value);
                      if (value.length == 0) {
                        setClientnameError("Please enter Client name");
                      }
                      else {
                        setClientNameValid(true);
                        setClientnameError("");
                      }
                    }}
                  />

                  <Text style={[styles.error_text]}>{ClientnameError}</Text>
                </View>

                <View
                  style={isMobile ? { marginLeft: -15, marginTop: -10 } : null}
                >
                  <Text style={styles.lableText}>Project Details</Text>
                  <TextInput
                    style={
                      isMobile
                        ? {
                            borderColor: "#c3c3c3",
                            width: "105%",
                            borderWidth: 1,
                            borderRadius: 4,
                            padding: 10,
                            marginTop: 4,
                            marginBottom: 6,
                          }
                        : styles.input
                    }
                    placeholder="Enter Projects details"
                    value={ProjectDetails}
                    onChangeText={(value) => {
                      setProjectDetailsValid(false);
                      setProjectDetails(value);
                      if (value.length == 0) {
                        setProjectDetailsError("Please enter Project details ");
                      }
                      else {
                        setProjectDetailsValid(true);
                        setProjectDetailsError("");
                      }
                    }}
                  />

                  <Text style={[styles.error_text]}>{ProjectNameError}</Text>
                </View>

                <View
                  style={isMobile ? { marginLeft: -15, marginTop: -10 } : null}
                >
                  <Text style={styles.lableText}>Location </Text>
                  <View style={{ flexDirection: "row" }}>
                    <TextInput
                      style={
                        isMobile
                          ? {
                              borderColor: "#c3c3c3",
                              width: "100%",
                              borderWidth: 1,
                              borderRadius: 4,
                              marginRight: 5,
                              padding: 10,
                              marginTop: 4,
                              marginBottom: 6,
                              backgroundColor: "#DEDEDE",
                            }
                          : [
                              styles.inputLocation,
                              { backgroundColor: "#DEDEDE" },
                            ]
                      }
                      maxLength={10}
                      editable={false}
                      keyboardType={"numeric"}
                      value={Lat}
                    />
                    <TextInput
                      style={
                        isMobile
                          ? {
                              borderColor: "#c3c3c3",
                              width: "100%",
                              borderWidth: 1,
                              borderRadius: 4,
                              marginRight: 5,
                              padding: 10,
                              marginTop: 4,
                              marginBottom: 6,
                              backgroundColor: "#DEDEDE",
                            }
                          : [
                              styles.inputLocation,
                              { backgroundColor: "#DEDEDE" },
                            ]
                      }
                      maxLength={10}
                      keyboardType={"numeric"}
                      editable={false}
                      keyboardType={"numeric"}
                      value={Long}
                    />
                    <IconLoc
                      name="my-location"
                      size={20}
                      style={{ margin: 10 }}
                    />
                  </View>
                </View>
                <View
                  style={isMobile ? { marginLeft: -15, marginTop: -10 } : null}
                >
                  <Text style={styles.lableText}>Based On</Text>
                  <View
                    style={
                      isMobile
                        ? {
                            flexDirection: "row",
                            marginTop: 5,
                            alignItems: "center",
                          }
                        : {
                            flexDirection: "row",
                            marginTop: 10,
                            alignItems: "center",
                          }
                    }
                  >
                    <Text>Omega</Text>
                    <RadioButton
                      value={isAssignchecked}
                      status={isAssignchecked === 1 ? "checked" : "unchecked"}
                      onPress={() => setAssignChecked(1)}
                    />
                    <Text>IMEI</Text>
                    <RadioButton
                      value={isAssignchecked}
                      status={isAssignchecked === 2 ? "checked" : "unchecked"}
                      onPress={() => setAssignChecked(2)}
                    />
                    <Text>Both</Text>
                    <RadioButton
                      value={isAssignchecked}
                      status={isAssignchecked === 3 ? "checked" : "unchecked"}
                      onPress={() => setAssignChecked(3)}
                    />
                  </View>
                </View>
              </View>
            </View>

            {DataRecord.length > 0 && (
              <View
                style={{ marginTop: 20, width: "41%", alignSelf: "center" }}
              >
                <TabView
                  navigationState={{ index, routes }}
                  renderScene={renderScene}
                  onIndexChange={setIndex}
                  initialLayout={{ width: layout.width }}
                  renderTabBar={(props) => (
                    <TabBar
                      {...props}
                      indicatorStyle={{
                        backgroundColor: "#2c7bbe",
                        height: 50,
                      }}
                      renderLabel={({ route, color }) => (
                        <Text style={{ color: "Black", margin: 8 }}>
                          {route.title}
                        </Text>
                      )}
                      style={{ backgroundColor: "#F6F9F9" }}
                    />
                  )} 
                />
              </View>
            )}

            <View
              style={{
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                backgroundColor: "#F6F9F9",
                width: "60%",
                marginBottom: 50,
              }}
            >
              {" "}
              <View style={[styles.card, { flexGrow: 1 }]}>
                <View
                  style={[
                    styles.shadowProp,
                    {
                      backgroundColor: "white",
                    },
                  ]}
                >
                  <View
                    style={
                      isMobile
                        ? {
                            width: "180%",
                            backgroundColor: "#F6F9F9",
                            marginLeft: -57,
                          }
                        : {
                            width: "120%",
                            backgroundColor: "#F6F9F9",
                          }
                    }
                  >
                    {dashboardName?.length > 0 && (
                      <View
                        style={{
                          borderWidth: 1,
                          borderColor: "#e3e0e0",
                        }}
                      >
                        <View>
                          <DataTable
                            columns={columnsDashboardName}
                            data={dashboardName}
                            customStyles={customDashboardNameStyles}
                           
                            pagination
                            paginationPerPage={5}
                            paginationRowsPerPageOptions={[5, 10, 15, 20, 25]}
                          />
                        </View>
                      </View>
                    )}
                  </View>
                </View>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "center",
                marginHorizontal: 20,
                marginBottom: 20,
              }}
            >
              <TouchableOpacity
                style={
                  isMobile
                    ? {
                        alignItems: "center",
                        backgroundColor: "#006EB9",
                        padding: 10,
                        borderWidth: 1,
                        borderColor: "#006EB9",
                        width: "70%",
                        marginRight: 10,
                      }
                    : styles.saveBtn
                }
                onPress={() => CheckEnteredData()}
              >
                <Text style={styles.btnText}>Update</Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={
                  isMobile
                    ? {
                        alignItems: "center",
                        backgroundColor: "#006EB9",
                        padding: 10,
                        borderWidth: 1,
                        borderColor: "#006EB9",
                        width: "70%",
                        marginRight: 10,
                      }
                    : styles.saveBtn
                }
                onPress={() => navigation.navigate("ProjectProfile")}
              >
                <Text style={styles.btnText}>Cancel</Text>
              </TouchableOpacity>
            </View>
          </View>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  genderNames: {
    margin: 7,
  },
  statusNames: {
    margin: 7,
  },
  containeralt: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 10,
    borderWidth: 1,
    height: "100%",
    marginRight: "10%",
    marginTop: "0%",
    margin: "auto",
    padding: 30,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "70%",
  },
  inputLocation: {
    borderColor: "#c3c3c3",
    width: "40%",
    borderWidth: 1,
    borderRadius: 4,
    marginRight: 5,
    padding: 10,
    marginTop: 4,
    marginBottom: 6,
  },
  input: {
    borderColor: "#c3c3c3",
    width: "100%",
    borderWidth: 1,
    borderRadius: 4,

    padding: 10,
    marginTop: 4,
    marginBottom: 6,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  addCountry: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "70%",
  },
  saveBtn: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "100%",
    marginRight: 10,
  },
  btnText: {
    color: "#fff",
    fontWeight: "600",
  },
  datePicker: {
    justifyContent: "center",
    alignItems: "flex-start",
    width: 320,
    height: 260,
    display: "flex",
  },
  card: {

    width: "100%",
    flex: 1,
    marginVertical: 0,
  },
  shadowProp: {
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 25,
  },

  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  error_text: {
    color: "red",
    fontSize: 14,
    fontWeight: "600",
    width: "70%",
    marginLeft: 0,
    marginBottom: 10,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },

  dropdown: {
    borderColor: "#c3c3c3",
    width: "70%",
    borderWidth: 1,
    borderRadius: 2,
    height: 40,
    outlineStyle: "none",

    padding: 10,
    marginTop: 5,
    marginBottom: 5,

  },
  icon: {
    marginRight: 5,
  },
  item: {
    padding: 17,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textItem: {
    flex: 1,
    fontSize: 16,
  },
  placeholderStyle: {
    fontSize: 16,
  },
  selectedTextStyle: {
    fontSize: 16,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
  },
  lableText: {
    color: "#484848",
    fontWeight: "700",
    marginTop: 18,
  },
});
